import { ReactElement, useState } from 'react';
import * as React from 'react';
import styles from './popin.module.scss';
import { useTranslation } from 'next-i18next';
import { IconEnum } from '@utmb/types/enum/IconEnum';
import { getColorStyle } from '@utmb/utils/colors';
import { ColorTypesEnum } from '@utmb/types/colors';
import { Icon } from '../icons/Icon';

interface PopinProps {
    children: React.ReactNode;
    closeCallback: () => void;
    isGrey?: boolean;
    noCross?: boolean;
    displayBorderRadius?: boolean;
    glassBorder?: boolean;
}

// Keep in sync with the exit animation duration in popin.module.scss.
const EXIT_ANIMATION_MS = 400;

export const Popin = ({ children, closeCallback, isGrey, noCross, displayBorderRadius, glassBorder }: PopinProps): ReactElement | null => {
    const [isClosing, setIsClosing] = useState(false);

    const handleClose = (): void => {
        // Only the glass (bottom-sheet) variant below xl animates out — wait for the
        // animation before unmounting. Otherwise close right away.
        const animatesOut = !!glassBorder && typeof window !== 'undefined' && window.matchMedia('(max-width: 1200px)').matches;
        if (!animatesOut) {
            closeCallback();
            return;
        }
        setIsClosing(true);
        window.setTimeout(closeCallback, EXIT_ANIMATION_MS);
    };

    return (
        <div className={styles.popin + ' ' + (isClosing ? styles.closing : '')}>
            <div
                className={
                    styles.container +
                    ' ' +
                    (isGrey ? styles.grey : '') +
                    ' ' +
                    (displayBorderRadius ? styles.rounded : '') +
                    ' ' +
                    (glassBorder ? styles.glassBorder : '')
                }
            >
                {noCross ? null : (
                    <button className={styles.cross} onClick={handleClose}>
                        <Icon variant={IconEnum.CLOSE} color={getColorStyle(ColorTypesEnum.PRIMARY)} width={20} height={20} />
                    </button>
                )}
                {children}
            </div>
        </div>
    );
};
